// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","modal-p":"Modal_modal-p__SgkXT"};